import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getIsOpPro, getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { getMemberPermissions, getResources, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    memberId: props.params.memberId,
  }),
  required: ["account", "memberId"],
  data: [{
    resource: "resources",
    url: () => {
      return {
        query: `{
          resources {
            id
            type
            alias
            name
            description
            updatedAt
            permissionLevel
          }
        }`,
      }
    },
  }, {
    resource: "memberPermissions",
    passthrough: true,
    url: ({ memberId }) => {
      return {
        id: `member-permissions-${memberId}`,
        query: `query ($memberId: IdOrEmail!) {
          member (id: $memberId) {
            name
            email
            id
            resourcePermissions {
              id
              type
              alias
              name
              description
              permissionLevel
              createdAt
              updatedAt
            }
          }
        }`,
        variables: {
          memberId,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    userId: get(state, "user.id"),
    role: getRole(state, props),
    resources: getResources(state, props),
    permissions: getMemberPermissions(state, props),
    isOpPro: getIsOpPro(state, props),
    datasetEntitlementsEnabled: getDatasetEntitlementsEnabled(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
